import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgSelectModule } from '@ng-select/ng-select';
import { BudgetplanFormRoutingModule } from './budgetplan-form-routing.module';
import { BudgetplanFormComponent } from './budgetplan-form.component';
import { MyDatePickerModule } from 'mydatepicker';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { SignaturePadModule } from 'angular2-signaturepad';
import { CurrencyMaskModule } from 'ng2-currency-mask';

@NgModule({
  declarations: [
    BudgetplanFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    GridModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    PdfViewerModule,
    NgSelectModule,
    BudgetplanFormRoutingModule,
    MyDatePickerModule,
    AccordionModule,
    SignaturePadModule,
    CurrencyMaskModule
  ],
  exports: [BudgetplanFormComponent],
  providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService],
})

export class BudgetplanFormModule { }
